import { Route } from '@angular/router';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { PasswordResetComponent } from 'src/app/pages/password-reset/password-reset.component';
import { RoutingID } from '../../sb-routing-enum';

export const login: Route = {
  path: 'login',
  component: LoginComponent,
  title: 'nav.signIn',
  data: {
    icon: '',
    breadcrumb: '',
    id: RoutingID.login,
  },
};

export const passwordReset: Route = {
  path: 'passwordReset',
  component: PasswordResetComponent,
  title: 'nav.passwordReset',
  data: {
    id: RoutingID.passwordReset,
  },
};
